import { Component } from '@angular/core';

@Component({
  selector: 'app-quehacemos',
  templateUrl: './quehacemos.component.html',
  styleUrls: ['./quehacemos.component.scss']
})
export class QuehacemosComponent {

}
